import React from 'react';
import _orderBy from 'lodash/orderBy';

import { IconDollarSign, InsightsIndexLogo } from '@trqk/components';
import { locale, formatDollarsStatement } from '@trqk/utils';

import { DataCard, DataCardTable } from '../components';
import { TopFiveEarningsPerPlayRow } from '.';
import { tooltipShim } from '../../../constants';

interface TopFiveEarningsPerPlayCardProps {
    data: InsightTopFiveEarningsPerPlayData[];
}

const earningsColor = 'secondary';

export const TopFiveEarningsPerPlayCard = ({
    data,
}: TopFiveEarningsPerPlayCardProps): JSX.Element => {
    const sortedAndSlicedData = _orderBy(
        data,
        ['earnings_per_play'],
        ['desc'],
    ).slice(0, 5);
    const cleanedData = sortedAndSlicedData.map(
        (
            item: InsightTopFiveEarningsPerPlayData,
        ): InsightTopFiveEarningsPerPlayData => {
            if (['not_reported', 'not reported'].includes(item?.source ?? '')) {
                return { ...item, source: '' };
            }

            return item;
        },
    );

    return (
        <DataCard
            title={
                locale.enUS.INSIGHTS.CARDS.TOP_FIVE.TOP_EARNINGS_PER_PLAY.TITLE
            }
            color={earningsColor}
            header={
                <>
                    {
                        locale.enUS.INSIGHTS.CARDS.TOP_FIVE
                            .TOP_EARNINGS_PER_PLAY.HEADER.PART_1
                    }
                    &nbsp;
                    <InsightsIndexLogo showLightning={false} />
                </>
            }
            Icon={IconDollarSign}
            inInsightsIndex={true}
        >
            {/*
                This keeps spacing consistent between cards that use a tooltip in the header and
                those that don't
            */}
            <div style={{ height: tooltipShim }} />
            <DataCardTable>
                {cleanedData.map(
                    (
                        {
                            earnings_per_play,
                            show,
                            source,
                        }: InsightTopFiveEarningsPerPlayData,
                        index: number,
                    ): JSX.Element => {
                        const earningsPerPlayFormatted =
                            earnings_per_play === null
                                ? ''
                                : formatDollarsStatement(earnings_per_play);

                        return (
                            <TopFiveEarningsPerPlayRow
                                key={`${show}.${source}`}
                                earningsColor={earningsColor}
                                earningsFormatted={earningsPerPlayFormatted}
                                index={index}
                                show={show}
                                source={source}
                            />
                        );
                    },
                )}
            </DataCardTable>
        </DataCard>
    );
};
